<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" :head-bg="'#17a7ff'" :spin-show="spinShow" :head-blur="false" v-model="activeTab">
    <div slot="slogan">
      <div class="message-tab">
        <!-- <Button type="text" style="color:#eee">未读</Button> | <Button type="text" style="color:#eee">已读</Button> -->
      </div>
    </div>
    <div class="activity-item mgui-container message-list" slot="/logs">
      <div v-if="logs.data.length>0">
        <Table stripe :columns="columns" :data="logs.data"></Table>
        <div class="pager"><Page :total="logs.total" :page-size="logs.per_page"  @on-change="pagerChange"></Page></div>
      </div>
      <div v-else style="padding:20px;text-align:center;color:#999">-- 没有消息 --</div>
    </div>
  </content-layout>
</template>


<script>
  import {fetch} from '../fetch/api'

  export default {
    name: 'Message',
    data () {
      return {
        title: '系统日志',
        headImage: '',
        tabs: [
          {'title': '系统日志', 'key': '/logs', 'visible': true}
        ],
        spinShow: true,
        activeTab: '/logs',
        currentMsg: [],
        logs: {
          data: []
        },
        columns: [
          {
            title: '类型',
            width: 160,
            key: 'title'
          },
          {
            title: '内容',
            key: 'content'
          },
          {
            title: '数据',
            width: 160,
            key: 'created_at'
          }
        ],
        params: {
          total: 0,
          page: 1
        }
      }
    },
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      messageChange () {
      },
      read (item) {
        if (item.status === 0) {
          item.status = 1
          // put(`console/messageStatus/${item.id}?status=${item.status}`).then(res => {
          //   let num = this.$store.state.badge.message - 1
          //   this.$store.dispatch('setBadge', {key: 'message', 'value': num})
          // })
        }
      },
      pagerChange (page) {
        this.params.page = page
        this.fetchData()
      },
      fetchData () {
        fetch(`console/logs/0`, {params: this.params}).then(res => {
          if (res.status === 'ok') {
            this.logs = res.result
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      }
    }
  }
</script>

<style scoped>

</style>
